import Button from '@zenbusiness/zui/Button';
import Heading from '@zenbusiness/zui/Heading';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import useUnfreezeCard from './hooks/useUnfreezeCard';

export default function UnfreezeCard() {
  const { unfreezeCard } = useUnfreezeCard();

  return (
    <Stack gap={{ xs: '32px', md: '40px' }}>
      <Heading
        family="secondary"
        size="2xl"
        weight="bold"
      >
        Virtual debit card details
      </Heading>
      <Stack gap="16px">
        <Text
          color="tertiary"
          size="xl"
        >
          Virtual card is frozen
        </Text>
        <Button
          color="secondary"
          onClick={unfreezeCard}
          size="large"
          sx={{ width: 'max-content' }}
          variant="contained"
        >
          Unfreeze
        </Button>
      </Stack>
    </Stack>
  );
}
